import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import CodeMirror from '@uiw/react-codemirror';
import { StreamLanguage } from '@codemirror/language';
import { msSQL } from '@codemirror/legacy-modes/mode/sql';

import { textToClipboard } from '../../utils/common';

const codeMirrorBasicSetup = {
  lineNumbers: false,
  highlightActiveLine: false,
  highlightActiveLineGutter: false,
  highlightSelectionMatches: false,
};

const Title = ({ toClipboard }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <div style={{ minWidth: 90 }}>SQL query</div>
    <div style={{ height: 23 }}>
      <Button style={{ margin: '-4px 30px' }} onClick={() => textToClipboard(toClipboard)}>
        copy to clipboard
      </Button>
    </div>
  </div>
);

const EventQueryExposureModal = ({ button, expose, sql, showButton, updatingItems, error }) => {
  const [visible, setVisible] = useState(false);

  const show = async () => {
    await expose();
    setVisible(true);
  };

  const hide = () => {
    setVisible(false);
  };

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onKeyDown={() => {}}
    >
      {showButton && button(show, updatingItems)}
      {visible && (
        <Modal
          title={sql ? <Title toClipboard={sql} /> : <div style={{ color: 'red' }}>ERROR</div>}
          open={visible && (!!sql || !!error)}
          onCancel={hide}
          footer={null}
          width={1200}
          bodyStyle={{
            height: 'calc(100vh - 282px)',
            padding: '0',
            overflow: 'auto',
          }}
        >
          {visible && (
            <CodeMirror
              value={sql || ''}
              extensions={[StreamLanguage.define(msSQL)]}
              readOnly
              basicSetup={codeMirrorBasicSetup}
              className="sql-query"
            />
          )}
        </Modal>
      )}
    </div>
  );
};

export default EventQueryExposureModal;
